import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import { confirmarEmail } from "../services/api";

const CHAVE_DESTINO = "eairh_destino_confirmacao";

// Só caminho interno — nunca "//outro-site".
const interno = (v) => (v && v.startsWith("/") && !v.startsWith("//") ? v : null);

export default function ConfirmarEmailPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  // DE ONDE A PESSOA VEIO. Sem isto, o link do e-mail levava sempre à home e quem estava no meio de uma
  // candidatura perdia a vaga (UOL 18:14, Soldador 19:37, Mecânico Montador 20:39 em 10/09/2026). O link traz
  // ?destino=; a cópia no navegador cobre e-mail antigo, mandado antes desta correção.
  const destino = (() => {
    const doLink = interno(params.get("destino"));
    if (doLink) return doLink;
    try { return interno(localStorage.getItem(CHAVE_DESTINO)); } catch { return null; }
  })();
  const [estado, setEstado] = useState("processando"); // processando | ok | erro
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setEstado("erro"); setMsg("Link inválido — falta o token."); return; }
    confirmarEmail(token)
      .then(() => { setEstado("ok"); })
      .catch((e) => { setEstado("erro"); setMsg(e.message || "Não foi possível confirmar."); });
  }, [token]);

  // Confirmou e tinha de onde vir: volta sozinho em 2 s (o botão fica para quem quiser ir antes).
  useEffect(() => {
    if (estado !== "ok" || !destino) return;
    try { localStorage.removeItem(CHAVE_DESTINO); } catch { /* nada a limpar */ }
    const t = setTimeout(() => navigate(destino, { replace: true }), 2000);
    return () => clearTimeout(t);
  }, [estado, destino, navigate]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-md mx-auto px-4 py-12">
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm text-center">
          {estado === "processando" && <p className="text-gray-500">Confirmando seu e-mail...</p>}
          {estado === "ok" && (
            <>
              <div className="text-4xl">✓</div>
              <h1 className="mt-2 text-xl font-bold text-green-700">E-mail confirmado!</h1>
              {destino ? (
                <>
                  <p className="mt-1 text-sm text-gray-600">Levando você de volta para onde parou...</p>
                  <Link to={destino} replace className="inline-block mt-4 rounded-xl bg-primary hover:bg-brand text-white font-semibold px-5 py-2 text-sm">
                    Continuar de onde parei →
                  </Link>
                </>
              ) : (
                <>
                  <p className="mt-1 text-sm text-gray-600">Sua conta agora tem o selo de verificação. Obrigado!</p>
                  <Link to="/" className="inline-block mt-4 text-sm text-primary font-semibold hover:underline">Ir para a página inicial →</Link>
                </>
              )}
            </>
          )}
          {estado === "erro" && (
            <>
              <div className="text-4xl">⚠️</div>
              <h1 className="mt-2 text-xl font-bold text-red-700">Não foi possível confirmar</h1>
              <p className="mt-1 text-sm text-gray-600">{msg}</p>
              <p className="mt-1 text-xs text-gray-400">O link pode já ter sido usado. Sua conta continua funcionando normalmente.</p>
              <Link to={destino || "/"} className="inline-block mt-4 text-sm text-primary font-semibold hover:underline">
                {destino ? "Continuar de onde parei" : "Voltar ao início"}
              </Link>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
